<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 3C6.41421 3 6.75 3.33579 6.75 3.75V5.25H8.25C8.66421 5.25 9 5.58579 9 6C9 6.41421 8.66421 6.75 8.25 6.75H6.75V8.25C6.75 8.66421 6.41421 9 6 9C5.58579 9 5.25 8.66421 5.25 8.25V6.75H3.75C3.33579 6.75 3 6.41421 3 6C3 5.58579 3.33579 5.25 3.75 5.25H5.25V3.75C5.25 3.33579 5.58579 3 6 3Z"
      fill="#868D9C"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.25 0C11.2165 0 12 0.783502 12 1.75L12 7.58594C12 8.05001 11.8155 8.49509 11.4873 8.82324L8.82324 11.4873C8.49509 11.8155 8.05001 12 7.58594 12L1.75 12C0.783502 12 0 11.2165 0 10.25L0 1.75C0 0.783502 0.783502 0 1.75 0L10.25 0ZM1.75 1.5C1.61193 1.5 1.5 1.61193 1.5 1.75L1.5 10.25C1.5 10.3881 1.61193 10.5 1.75 10.5L7.58594 10.5C7.65219 10.5 7.71585 10.4736 7.7627 10.4268L10.4268 7.7627C10.4736 7.71585 10.5 7.65219 10.5 7.58594L10.5 1.75C10.5 1.61193 10.3881 1.5 10.25 1.5L1.75 1.5Z"
      fill="#868D9C"
    />
  </svg>
</template>
